// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SettingsSidebar.css */

:root {
  --sidebar-bg: #0c1e35;
  --sidebar-secondary-bg: #0b1a2c;
  --text-color: #7d84ab;
  --text-hover: #dee2ec;
  --border-color: rgba(83, 93, 125, 0.3);
}

.settings-sidebar {
  width: 260px;
  height: 100vh;
  background: var(--sidebar-bg);
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
}

.settings-sidebar.collapsed {
  transform: translateX(-100%);
}

.settings-sidebar__header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bold;
  background: var(--sidebar-secondary-bg);
}

.settings-sidebar__toggle {
  cursor: pointer;
  font-size: 22px;
  color: var(--text-hover);
  transition: color 0.3s;
}

.settings-sidebar__toggle:hover {
  color: white;
}

.settings-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.settings-menu__item {
  padding: 15px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.3s;
}

.settings-menu__item i {
  font-size: 20px;
  margin-right: 10px;
}

.settings-menu__item:hover {
  background: var(--sidebar-secondary-bg);
  color: var(--text-hover);
}

.settings-menu__item.active {
  background: var(--sidebar-secondary-bg);
  color: white;
  font-weight: bold;
}

/* Submenu Styling */
.settings-submenu {
  padding-left: 20px;
  display: none;
}

.settings-menu__item.open .settings-submenu {
  display: block;
}

.settings-submenu li {
  padding: 10px 20px;
  cursor: pointer;
}

.settings-submenu li:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* Responsive */
@media (max-width: 768px) {
  .settings-sidebar {
    width: 220px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/SettingsPage.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAGxB;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* SettingsSidebar.css */\n@import url('https://fonts.googleapis.com/css?family=Poppins:400,600&display=swap');\n\n:root {\n  --sidebar-bg: #0c1e35;\n  --sidebar-secondary-bg: #0b1a2c;\n  --text-color: #7d84ab;\n  --text-hover: #dee2ec;\n  --border-color: rgba(83, 93, 125, 0.3);\n}\n\n.settings-sidebar {\n  width: 260px;\n  height: 100vh;\n  background: var(--sidebar-bg);\n  color: var(--text-color);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  top: 0;\n  overflow-y: auto;\n  transition: transform 0.3s ease-in-out;\n  z-index: 1000;\n}\n\n.settings-sidebar.collapsed {\n  transform: translateX(-100%);\n}\n\n.settings-sidebar__header {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 18px;\n  font-weight: bold;\n  background: var(--sidebar-secondary-bg);\n}\n\n.settings-sidebar__toggle {\n  cursor: pointer;\n  font-size: 22px;\n  color: var(--text-hover);\n  transition: color 0.3s;\n}\n\n.settings-sidebar__toggle:hover {\n  color: white;\n}\n\n.settings-menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.settings-menu__item {\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.settings-menu__item i {\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.settings-menu__item:hover {\n  background: var(--sidebar-secondary-bg);\n  color: var(--text-hover);\n}\n\n.settings-menu__item.active {\n  background: var(--sidebar-secondary-bg);\n  color: white;\n  font-weight: bold;\n}\n\n/* Submenu Styling */\n.settings-submenu {\n  padding-left: 20px;\n  display: none;\n}\n\n.settings-menu__item.open .settings-submenu {\n  display: block;\n}\n\n.settings-submenu li {\n  padding: 10px 20px;\n  cursor: pointer;\n}\n\n.settings-submenu li:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .settings-sidebar {\n    width: 220px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
